import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { productApi } from "../../api/api";

const KEY = "products";

export function useProducts() {
  return useQuery({
    queryKey: [KEY],
    queryFn: productApi.getAll,
  });
}

export function useProduct(id) {
  return useQuery({
    queryKey: [KEY, id],
    queryFn: () => productApi.getById(id),
    enabled: !!id,
  });
}

export function useCreateProduct() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: productApi.create,
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
  });
}

export function useCreateCompositeProduct() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: productApi.createComposite,
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
  });
}

export function useUpdateProduct() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: productApi.update,
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
  });
}

export function useDeleteProduct() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => productApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
  });
}
